var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35","viewBox":"0 0 23 22","fill":"none"}},[_c('rect',{attrs:{"x":"0.451172","y":"0.222656","width":"21.664","height":"21.664","rx":"10.832","fill":"#F9FAFB"}}),_c('circle',{attrs:{"cx":"11.2835","cy":"11.056","r":"3.61067","fill":"#E4E7EC"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }